export default "__VITE_ASSET__D2XHzcoz__"